import {GradingSystem, Route, RouteMeta} from "./_types";

declare global {
    interface Window {
        ClimbPressPublic: {
            RESTNamespace: string
            gradingSystems: GradingSystem[]
            metaStructure: RouteMeta[]
            labels: { [key: string]: string }
            fetchRoutes(url?: string): Promise<Route[]>
            vote(route_id: number, difficulty: number): Promise<string|false>
            changeVote(vote_id: string, difficulty: number): Promise<boolean>
            unvote(vote_id: string): Promise<boolean>
        }
    }
}

if(window.ClimbPressPublic.fetchRoutes == undefined){
    window.ClimbPressPublic = {
        ...window.ClimbPressPublic,
        async fetchRoutes (url = "/wp-json/climbpress/v1/routes") {
            return fetch(url).then(res => res.json());
        },
        async vote(route_id, difficulty){
            const result = await fetch(`/wp-json/climbpress/v1/votes`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    route_id,
                    difficulty,
                })
            }).then(res=> res.json()) as { voting_id: string|false};
            return result.voting_id;
        },
        async changeVote(voting_id, difficulty){
            const result = await fetch(`/wp-json/climbpress/v1/votes`,{
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    voting_id,
                    difficulty,
                })
            }).then(res=> res.json()) as { success: boolean};
            return result.success;
        },
        async unvote(vote_id){
            const result = await fetch(`/wp-json/climbpress/v1/votes`,{
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: vote_id,
                })
            }).then(res=> res.json());
            return result as boolean;
        }

    }
}

export const fetchRoutes = window.ClimbPressPublic.fetchRoutes;
export const getGradingSystems = () => window.ClimbPressPublic.gradingSystems;
export const vote = window.ClimbPressPublic.vote;
export const unvote = window.ClimbPressPublic.unvote;
export const changeVote = window.ClimbPressPublic.changeVote;
export const getLabels = () => window.ClimbPressPublic.labels;
